import React, { useEffect, useState } from "react";
import { postData } from "../../api";
import { PortfolioCard } from "./ap";
import "../actualportfolio/actualportfolio.css";
import {  getAllPortfolioProjects } from "../../utils/imageLoader";
import ProjectDetailsModal from "./ProjectDetailsModal";

function ProtfolioList() {
  const [data, setData] = useState([]);
  const [filterKey, setFilterKey] = useState(".webapplicatioin");
  const [activetab, setActivetab] = useState(2);
  const [filteredData, setFilteredData] = useState([]);
  const [animationClass, setAnimationClass] = useState("");
  const [selectedProject, setSelectedProject] = useState(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    // Get all projects (merged from portfolioData and local images)
    const projects = getAllPortfolioProjects();
    console.log('projects', projects);
    setData(projects);
  }, []);

  useEffect(() => {
    setAnimationClass("fade-exit");
    setTimeout(() => {
      let filtered = data;
      if (filterKey === ".webapplicatioin") {
        filtered = data.filter(item => item.Section === "WEB");
      } else if (filterKey === ".webdevlopment") {
        filtered = data.filter(item => item.Section === "APP");
      } else if (filterKey === ".reports") {
        filtered = data.filter(item => item.Section === "REPORTS");
      } 
      else if (filterKey === ".automation") {
        filtered = data.filter(item => item.Section === "AUTOMATION");
      }
      else if (filterKey === ".cloud") {
        filtered = data.filter(item => item.Section === "CLOUD");
      }
      setFilteredData(filtered);
      setAnimationClass("fade-enter");
    }, 500);
  }, [data, filterKey]);

  const handleFilterKeyChange = (key) => () => {
    setFilterKey(key);
    if (key === "*") setActivetab(2);
    else if (key === ".webapplicatioin") setActivetab(2);
    else if (key === ".webdevlopment") setActivetab(3);
    else if (key === ".reports") setActivetab(4);
    else if (key === ".automation") setActivetab(5);
    else if (key === ".cloud") setActivetab(6);
  };

  const handleProjectClick = (project) => {
    setSelectedProject(project);
    setShowModal(true);
  };

  return (
    <>
      {/* <div className="breatcome_area">
        <div className="text_overlay">
          <h2>Portfolio</h2>
          <p>Home || Portfolio</p>
        </div>
      </div> */}
      <div className="portfolio_area py-5 mt-header" id="portfolio">
        <div className="container">
          <div className="row mt-0">
            <div className="col-lg-12">
              <div className="section_title text_center mb-25 ">
                {/* <div className="section_sub_title uppercase mb-3">
                  <h6>PORTFOLIO</h6>
                </div> */}
                <div className="section_main_title">
                  <h1>Our Latest Works For Your Business</h1>
                </div>
              </div>
            </div>
          </div>

          <div className="row mb-4 mt-0">
            <div className="col-lg-12 text-center justify-content-center d-flex">
              <ul className="portfolio-filter">
                {/* <li
                  className={`Btn ${activetab === 1 ? "active" : ""}`}
                  onClick={handleFilterKeyChange("*")}
                >
                  All Works
                </li> */}
                <li
                  className={`Btn ${activetab === 2 ? "active" : ""}`}
                  onClick={handleFilterKeyChange(".webapplicatioin")}
                >
                  Web Application
                </li>
                <li
                  className={`Btn ${activetab === 3 ? "active" : ""}`}
                  onClick={handleFilterKeyChange(".webdevlopment")}
                >
                  App Development
                </li>
                <li
                  className={`Btn ${activetab === 4 ? "active" : ""}`}
                  onClick={handleFilterKeyChange(".reports")}
                >
                  Reports - Power BI & Power Apps
                </li>
                {/* <li
                  className={`Btn ${activetab === 5 ? "active" : ""}`}
                  onClick={handleFilterKeyChange(".automation")}
                >
                  Power Automation
                </li> */}
                <li
                  className={`Btn ${activetab === 6 ? "active" : ""}`}
                  onClick={handleFilterKeyChange(".cloud")}
                >
                  Cloud Development
                </li>
              </ul>
            </div>
          </div>

          <div className="row">
            {filteredData.map((x, i) => {
              let type =
                x.Section === "WEB"
                  ? "col-xl-4 col-lg-6 col-md-6 col-sm-12 mt-2" 
                  : "col-xl-4 col-lg-6 col-md-6 col-sm-12 mt-2";
              
              return (
                <div className={`${type} ${animationClass}`} key={i}>
                  <div className="d-flex justify-content-center">
                    <PortfolioCard
                      technology={x.technology}
                      src={x.localImageSrc}
                      title={x.projectName}
                      shortDescription={x.shortDescription} 
                      Section ={x.Section}
                      Url = {x.reportsUrl}
                      onClick={() => handleProjectClick(x)}
                    />
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      
      <ProjectDetailsModal 
        show={showModal} 
        onHide={() => setShowModal(false)} 
        project={selectedProject} 
      />
    </>
  );
}

export default ProtfolioList;
